'use strict';

module.exports = (element, key) => {};